import C from "./ghl-ui.es1165.js";
import g from "./ghl-ui.es1145.js";
import { changeColor as i } from "./ghl-ui.es895.js";
const S = (a) => {
  const { borderColor: t, primaryColor: o, baseColor: e, textColorDisabled: l, inputColorDisabled: n, textColor2: r, opacityDisabled: b, borderRadius: d, fontSizeSmall: s, fontSizeMedium: h, fontSizeLarge: u, heightSmall: x, heightMedium: c, heightLarge: m, lineHeight: p } = a;
  return Object.assign(Object.assign({}, C), {
    labelLineHeight: p,
    buttonHeightSmall: x,
    buttonHeightMedium: c,
    buttonHeightLarge: m,
    fontSizeSmall: s,
    fontSizeMedium: h,
    fontSizeLarge: u,
    boxShadow: `inset 0 0 0 1px ${t}`,
    boxShadowActive: `inset 0 0 0 1px ${o}`,
    boxShadowFocus: `inset 0 0 0 1px ${o}, 0 0 0 2px ${i(o, { alpha: 0.2 })}`,
    boxShadowHover: `inset 0 0 0 1px ${o}`,
    boxShadowDisabled: `inset 0 0 0 1px ${t}`,
    color: e,
    colorDisabled: n,
    colorActive: "#0000",
    textColor: r,
    textColorDisabled: l,
    dotColorActive: o,
    dotColorDisabled: t,
    buttonBorderColor: t,
    buttonBorderColorActive: o,
    buttonBorderColorHover: t,
    buttonColor: e,
    buttonColorActive: e,
    buttonTextColor: r,
    buttonTextColorActive: o,
    buttonTextColorHover: o,
    opacityDisabled: b,
    buttonBoxShadowFocus: `inset 0 0 0 1px ${o}, 0 0 0 2px ${i(o, { alpha: 0.3 })}`,
    buttonBoxShadowHover: "inset 0 0 0 1px #0000",
    buttonBoxShadow: "inset 0 0 0 1px #0000",
    buttonBorderRadius: d
  });
}, v = {
  name: "Radio",
  common: g,
  self: S
}, w = v;
export {
  w as default
};
